import {Routes} from "@angular/router";
import {DcDocsPage} from "./page/overview/dc-config/dc-docs.page";
import {DcConfigPage} from "./page/overview/dc-config/dc-config.page";

export function DcSubRoutes() : Routes {

    /**
     *
     * path:
     * Prefix of the module will always be added to the path name
     *
     *      Example
     *      path: "addresses" => route path "ad/addresses" !
     * ------------------------------------------------------------------
     *
     * canActivate:
     * The authentication guard MsalGuard will be added automatically!
     * ------------------------------------------------------------------
     *
     * component:
     * Added components need to be from type "Page"!
     * ------------------------------------------------------------------
     *
     */
    const routes = [
        // {path: 'dc/docs/:id', component: DcDocsPage },
        {path: 'dc/docs', component: DcDocsPage},
        {path: 'dc/config', component: DcConfigPage},
    ];

    return routes;

}
